var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFace = function SvgFace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 506,
    viewBox: "0 0 355 506",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.34 481.773H164.028L126.632 470.646L126.319 470.435L79.1317 411.701L79.0623 411.595L59.3401 375.115L59.2706 374.939L51.1109 337.156L42.0137 327.015L32.7776 318.353L32.5692 317.93L32.222 300.536L28.8192 259.372L24.5137 238.351L24.7915 237.682L32.9512 233.034L33.7845 233.28L38.5067 242.964L37.1178 152.503L37.1526 152.257L70.8331 67.9587L71.1109 67.6418L125.069 37.6762L125.278 37.6057L175.972 31.3027H176.111L226.111 37.7466L226.354 37.817L278.229 70.0714L278.472 70.3883L307.257 153.56L307.291 153.806L302.396 243.28L306.18 234.16L306.979 233.844L317.569 238.914L317.916 239.583L313.09 265.57L312.257 296.486L309.687 322.297L309.479 322.719L298.055 332.051L285.451 342.79L276.84 381.946L276.771 382.122L257.5 416.806L257.43 416.912L209.965 471.456L209.653 471.632L164.34 481.773ZM127.187 469.519L164.236 480.541L209.201 470.54L256.528 416.208L275.729 381.629L284.375 342.368L284.583 342.016L297.326 331.135L308.576 321.945L311.111 296.416L311.944 265.499V265.394L316.701 239.794L307.118 235.217L302.222 247.013L301.076 246.731L306.146 153.877L277.465 71.0221L225.868 38.9438L176.041 32.5L125.521 38.7677L71.8748 68.6277L38.2984 152.609L39.722 245.64L38.5762 245.921L32.9859 234.407L25.7637 238.527L29.9998 259.232L33.4026 300.465L33.7498 317.649L42.847 326.17L52.1526 336.487L52.2915 336.769L60.4512 374.622L80.104 410.961L127.187 469.519Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.847 166.728L171.805 166.693L134.027 98.0288L134.548 97.1133L216.076 97.2541L216.597 98.2049L172.847 166.728ZM135.59 98.3457L172.361 165.214L215 98.4866L135.59 98.3457Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8469 137.044L71.9441 136.551L70.833 68.2392L71.7011 67.6758L134.791 97.1836L134.861 98.2752L72.8469 137.044ZM72.0483 69.1547L73.1247 135.424L133.298 97.7823L72.0483 69.1547Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.347 137.046L215.764 98.3478L215.868 97.2914L277.743 70.0371L278.576 70.6709L271.284 136.623L270.347 137.046ZM217.326 97.9956L270.208 135.497L277.222 71.6217L217.326 97.9956Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59 98.1703L176.042 33.0629L135.069 98.0647L133.958 97.8182L124.757 38.3095L125.972 38.0983L134.896 96.0224L175.555 31.584H176.562L215.764 96.1633L225.486 38.2391L226.667 38.4504L216.701 97.9591L215.59 98.1703Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.43 218.314L260.59 193.631L260.416 193.067L270.138 136.446L271.006 135.988L307.048 153.207L307.36 153.947L288.437 218.033L287.43 218.314ZM261.631 192.962L287.534 216.765L306.041 154.123L271.18 137.467L261.631 192.962Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0973 411.56L51.1807 337.157L51.3196 336.487L82.1529 306.275L83.1598 306.663L88.9585 380.608L88.9237 380.82L80.2084 411.49L79.0973 411.56ZM52.4654 337.086L79.5834 409.412L87.7779 380.608L82.0834 308.071L52.4654 337.086Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.951 381.066L51.2843 337.332L51.1454 337.015L38.5412 245.745L38.6107 245.393L53.6454 216.307L37.1523 152.644L37.4648 151.939L72.2912 135.988L73.1246 136.481L78.6107 190.004L172.187 165.778L270.52 135.953L271.284 136.411L288.402 217.751L287.222 217.998L270.243 137.326L172.5 166.975L78.2287 191.377L77.4996 190.849L72.0135 137.432L38.4371 152.855L54.8607 216.237L54.826 216.695L39.7912 245.78L52.326 336.663L88.8537 380.256L87.951 381.066Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7912 217.154L54.0273 216.203L77.4301 190.533L77.9857 190.357L136.25 200.428L136.18 201.625L77.0482 203.456L54.7912 217.154ZM78.0898 191.625L57.8121 213.844L76.5273 202.33L76.8051 202.224L130.069 200.569L78.0898 191.625Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.681 232.54L54.5139 217.434L54.0625 216.695L71.9444 136.411L72.7083 135.953L172.5 165.778L261.146 192.61L261.111 193.772L209.687 205.533L257.847 205.11L257.882 206.342L204.062 206.8L203.924 205.603L258.611 193.103L172.153 166.975L72.9861 137.291L55.3819 216.413L106.528 230.674L76.6319 203.561L76.4236 203.068L77.2569 190.919L78.4722 191.025L77.6736 202.821L109.236 231.484L108.681 232.54Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.493 416.877L238.681 386.771L238.611 386.313L254.479 310.36L255.521 310.079L284.584 341.171L301.042 246.873L287.396 218.351L257.639 206.308L257.292 205.604L260.417 193.068L261.597 193.35L258.611 205.393L288.09 217.33L288.403 217.646L302.257 246.556L302.292 246.943L285.521 342.615L285.347 342.685L285.486 342.756L257.57 416.807L256.493 416.877ZM239.827 386.348L256.875 415.152L284.236 342.615L255.382 311.769L239.827 386.348Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.764 407.475H165.556L139.549 401.489L139.41 401.454L110.486 386.911L110.764 385.749L165.868 385.221H165.903L214.931 388.707L215.209 389.834L192.014 403.496L191.806 403.566L165.764 407.475ZM139.896 400.292L165.695 406.242L191.493 402.369L212.882 389.763L165.834 386.418L113.299 386.946L139.896 400.292Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.694 227.33L135.798 201.52L135.729 200.569L172.152 165.709L173.159 166.167L171.666 226.837L170.694 227.33ZM137.083 200.992L170.485 225.675L171.909 167.646L137.083 200.992Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.576 241.941L162.534 241.378L170.52 226.554L170.729 226.342L203.298 206.025L172.083 166.587L173.02 165.812L204.687 205.814L204.513 206.694L171.493 227.293L163.576 241.941Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.014 306.909L38.6807 246.027L39.1321 245.076L79.7223 242.436L80.3473 243.034L83.0904 306.557L82.014 306.909ZM40.2779 246.203L81.8057 304.515L79.1668 243.668L40.2779 246.203Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1391 243.491L79.3058 243.455L54.2363 217.257L54.9308 216.271L90.5558 233.455L90.6947 234.476L80.1391 243.491ZM57.4308 218.842L79.7919 242.188L89.2016 234.159L57.4308 218.842Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.604 245.887L251.909 234.338L234.479 230.359V229.161L287.708 217.26L288.298 218.281L263.506 245.887H262.604ZM237.395 229.76L252.36 233.176L252.673 233.352L263.055 244.584L286.11 218.88L237.395 229.76Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.958 231.343L108.717 232.551L122.736 235.435L122.978 234.227L108.958 231.343Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.646 256.943L92.9861 255.147L92.6389 255.006L79.375 243.492L80.1389 242.576L93.2986 253.95L113.576 255.71L131.424 247.4L122.361 235.182L122.292 234.583L134.479 204.23L109.271 232.329L108.889 232.541L90.3819 234.653L90.2431 233.421L108.542 231.343L135.868 200.85L136.875 201.483L123.542 234.724L132.847 247.295L132.604 248.21L113.924 256.907L113.646 256.943Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.465 255.887L226.423 254.021H226.284L208.02 248.281L207.777 247.26L220.243 235.112L220.416 234.971L234.27 229.231L257.43 205.287L258.298 206.167L235.034 230.182L234.826 230.288L221.007 236.063L209.375 247.401L226.597 252.824L247.361 254.655L262.708 244.936L263.368 245.992L247.847 255.781L247.465 255.887Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.604 247.752L203.507 206.307L204.479 205.779L234.965 229.266L234.236 230.217L204.861 207.61L208.819 247.611L207.604 247.752Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.576 217.319L251.953 233.223L252.443 234.351L288.066 218.447L287.576 217.319Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.795 226.87L170.654 227.295L175.599 240.946L176.74 240.521L171.795 226.87Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.097 471.525L167.083 429.27L127.257 470.469L126.25 469.941L139.097 400.784L140.104 400.467L167.083 427.58L191.285 402.544L192.292 402.826L210.139 470.962L209.097 471.525ZM167.917 428.425L208.368 469.095L191.389 404.164L167.917 428.425ZM140.069 402.122L127.812 468.18L166.25 428.425L140.069 402.122Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.284 470.294L87.8467 380.925L88.5411 380.08L110.902 385.749L111.354 386.242L127.465 469.942L126.284 470.294ZM89.4439 381.559L125.208 464.695L110.243 386.841L89.4439 381.559Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.583 343.458L82.1181 307.014L81.875 306.415L92.4306 254.406L93.5764 254.301L130.486 342.719L129.583 343.458ZM83.1597 306.274L128.507 341.064L93.2292 256.554L83.1597 306.274Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.312 326.733L131.771 247.787L132.882 247.33L154.27 282.295L162.465 241.52L163.645 241.766L155.139 284.021L154.027 284.232L133.819 251.168L151.493 326.451L150.312 326.733Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41 284.338L183.334 284.091L176.215 244.372L170.452 276.661H169.271L162.57 242.33L132.465 248.245L131.736 247.576L135.695 201.202L136.806 200.92L163.368 241.027L175.59 240.921L175.556 240.815L175.938 240.745L203.507 205.955L204.514 206.026L221.181 235.181L220.139 235.78L203.889 207.399L177.188 241.097L208.299 247.048L208.681 247.999L184.41 284.338ZM177.084 242.365L184.236 282.436L207.188 248.104L177.084 242.365ZM163.785 242.259L169.827 273.281L175.382 242.153L163.785 242.259ZM136.771 203.033L133.021 246.872L162.014 241.203L136.771 203.033Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.659 247.5L182.924 327.207L184.083 327.577L208.818 247.87L207.659 247.5Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.777 349.903H166.805L150.798 327.473L130.312 343.459L129.34 343.072L113.472 256.485L114.583 256.098L151.18 325.889L168.229 321.346H168.576L183.124 326.628L225.868 253.105L226.979 253.563L205.555 338.706L246.909 255.006L248.055 255.182L254.93 305.818L262.361 245.393L262.986 244.865L301.597 246.203L302.048 247.189L255.416 310.923H255.347L255.242 311.099L203.854 344.621L203.159 344.586L183.472 328.318L167.777 349.903ZM151.909 326.98L167.291 348.53L182.465 327.72L168.402 322.579L151.909 326.98ZM184.236 327.262L203.298 343.002L224.826 257.471L184.236 327.262ZM247.187 257.295L205.173 342.333L254.409 310.219L247.187 257.295ZM115.381 260.183L130.347 341.875L150.138 326.452L115.381 260.183ZM263.576 246.098L255.937 308.282L300.52 247.365L263.576 246.098Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.618 378.636L178.576 378.495L167.326 351.135L156.875 378.143L155.833 378.284L129.444 343.318L130.035 342.332L167.292 348.917L203.542 343.424L204.132 344.374L179.618 378.636ZM168.16 350.043L179.271 377.051L202.326 344.867L168.16 350.043ZM131.354 343.846L156.146 376.734L166.458 350.043L131.354 343.846Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.666 396.807H166.493L110.659 386.947L110.833 385.75L166.597 395.609L214.791 388.673L214.965 389.905L166.666 396.807Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.007 407.404L165.312 407.369L146.91 393.53L140.069 401.348H139.201L128.194 389.939L129.062 389.094L139.583 400.045L146.354 392.298L147.187 392.228L165.694 406.137L184.861 393.038L185.694 393.178L191.701 401.911L199.722 391.03L200.694 391.77L192.187 403.32H191.215L185.035 394.376L166.007 407.404Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.604 388.073L188.784 382.017L165.937 386.418H165.729L141.631 381.383L138.298 386.418L137.291 385.749L140.833 380.362L141.458 380.115L165.833 385.186L188.958 380.749L189.548 380.996L193.61 387.404L192.604 388.073Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.882 327.543L170.347 280.675L169.062 321.944L167.847 321.909L169.167 280.147L151.493 326.803L150.312 326.522L153.958 283.844L154.306 283.352L169.618 276.027H170.139L184.201 283.457L184.514 284.021L184.062 327.402L182.882 327.543ZM170.799 277.753L182.917 322.965L183.299 284.373L170.799 277.753ZM155.139 284.302L151.91 322.332L168.75 277.788L155.139 284.302Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.861 480.998H163.646L165.277 406.841L166.076 396.066L167.291 396.172L166.458 406.877L164.861 480.998Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.104 471.315L208.924 471.068L214.236 389.728L179.167 378.953L166.111 386.348L165.452 386.277L156.146 378.601L110.834 386.946H110.59L88.2294 381.277L87.9863 380.221L129.549 342.509L130.486 343.213L111.771 385.538L156.216 377.333L156.702 377.474L165.903 385.08L178.82 377.756L179.271 377.721L214.028 388.39L203.056 344.199L204.097 343.671L239.236 385.573L284.514 342.051L285.347 342.931L239.688 386.77L210.104 471.315ZM215.452 389.834L210.417 466.737L238.299 387.158L215.452 389.834ZM204.861 346.452L215.313 388.637L237.952 385.996L204.861 346.452ZM89.653 380.362L110.417 385.644L128.264 345.361L89.653 380.362Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.382 311.028L254.861 309.937L311.84 265.111L312.57 266.097L257.847 309.162L311.563 295.816L311.875 297.014L255.382 311.028Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4997 307.331L32.5344 301.169L32.708 299.936L80.7288 305.887L28.958 259.794L29.7566 258.879L82.9858 306.275L82.4997 307.331Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.681 256.591L108.681 233.245L93.6461 254.76L92.6738 254.056L108.507 231.379L109.584 231.625L114.861 256.344L113.681 256.591Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.423 256.59L235.659 231.132L226.979 253.809L225.833 253.351L235.069 229.301L236.18 229.266L247.534 256.097L246.423 256.59Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.298 322.543L295.59 278.387L295.659 277.929L316.84 239.195L317.916 239.794L296.805 278.316L309.444 322.226L308.298 322.543Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.779 278.209L295.564 278.244L297.084 331.64L298.299 331.604L296.779 278.209Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7844 318.036L32.6038 317.789L42.0483 271.274L24.583 238.526L25.6247 237.928L43.1941 270.922L43.2636 271.309L33.7844 318.036Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0824 271.209L41.834 326.598L43.0493 326.603L43.2977 271.214L42.0824 271.209Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0668 374.231L59.8271 375.439L88.286 381.245L88.5256 380.036L60.0668 374.231Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.215 381.245L239.131 385.855L239.279 387.079L276.363 382.468L276.215 381.245Z",
    fill: "#CCFFFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 272,
    width: 76,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255 347.897C260.104 348.109 264.861 347.017 269.305 344.658C273.923 343.144 277.882 340.538 281.25 336.876C284.861 333.46 287.43 329.411 288.923 324.763C291.25 320.291 292.326 315.432 292.118 310.255C291.667 306.91 291.25 303.6 290.798 300.255C289.028 293.882 285.868 288.353 281.25 283.635C278.75 281.663 276.25 279.726 273.75 277.755C267.951 274.339 261.701 272.649 255 272.614C249.896 272.402 245.139 273.494 240.694 275.853C236.076 277.367 232.118 279.973 228.75 283.635C225.139 287.051 222.569 291.1 221.076 295.748C218.75 300.22 217.673 305.079 217.882 310.255C218.333 313.601 218.75 316.911 219.201 320.256C220.972 326.629 224.132 332.158 228.75 336.876C231.25 338.848 233.75 340.785 236.25 342.756C242.083 346.172 248.333 347.897 255 347.897Z",
    fill: "url(#paint0_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255 347.897C260.104 348.109 264.861 347.017 269.305 344.658C273.923 343.144 277.882 340.538 281.25 336.876C284.861 333.46 287.43 329.411 288.923 324.763C291.25 320.291 292.326 315.432 292.118 310.255C291.667 306.91 291.25 303.6 290.798 300.255C289.028 293.882 285.868 288.353 281.25 283.635C278.75 281.663 276.25 279.726 273.75 277.755C267.951 274.339 261.701 272.649 255 272.614C249.896 272.402 245.139 273.494 240.694 275.853C236.076 277.367 232.118 279.973 228.75 283.635C225.139 287.051 222.569 291.1 221.076 295.748C218.75 300.22 217.673 305.079 217.882 310.255C218.333 313.601 218.75 316.911 219.201 320.256C220.972 326.629 224.132 332.158 228.75 336.876C231.25 338.848 233.75 340.785 236.25 342.756C242.083 346.172 248.333 347.897 255 347.897Z",
    fill: "url(#paint1_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M255.069 315.256C260.416 315.256 260.451 306.805 255.069 306.805C249.722 306.805 249.722 315.256 255.069 315.256Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 304,
    width: 75,
    height: 77
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.687 380.011C134.792 380.222 139.548 379.13 143.993 376.771C148.611 375.257 152.569 372.651 155.937 368.989C159.548 365.574 162.118 361.524 163.611 356.876C165.937 352.404 167.014 347.545 166.805 342.369C166.354 339.024 165.937 335.714 165.486 332.369C163.715 325.995 160.555 320.467 155.937 315.748C153.437 313.776 150.937 311.84 148.437 309.868C142.639 306.452 136.389 304.762 129.687 304.727C124.583 304.516 119.826 305.607 115.382 307.966C110.764 309.481 106.805 312.086 103.437 315.748C99.8262 319.164 97.2568 323.213 95.7637 327.861C93.4374 332.333 92.361 337.193 92.5693 342.369C93.0207 345.714 93.4374 349.024 93.8887 352.369C95.6596 358.743 98.8193 364.271 103.437 368.989C105.937 370.961 108.437 372.898 110.937 374.87C116.736 378.285 122.986 379.975 129.687 380.011Z",
    fill: "url(#paint2_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.687 380.011C134.792 380.222 139.548 379.13 143.993 376.771C148.611 375.257 152.569 372.651 155.937 368.989C159.548 365.574 162.118 361.524 163.611 356.876C165.937 352.404 167.014 347.545 166.805 342.369C166.354 339.024 165.937 335.714 165.486 332.369C163.715 325.995 160.555 320.467 155.937 315.748C153.437 313.776 150.937 311.84 148.437 309.868C142.639 306.452 136.389 304.762 129.687 304.727C124.583 304.516 119.826 305.607 115.382 307.966C110.764 309.481 106.805 312.086 103.437 315.748C99.8262 319.164 97.2568 323.213 95.7637 327.861C93.4374 332.333 92.361 337.193 92.5693 342.369C93.0207 345.714 93.4374 349.024 93.8887 352.369C95.6596 358.743 98.8193 364.271 103.437 368.989C105.937 370.961 108.437 372.898 110.937 374.87C116.736 378.285 122.986 379.975 129.687 380.011Z",
    fill: "url(#paint3_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M129.757 347.369C135.104 347.369 135.138 338.918 129.757 338.918C124.409 338.918 124.409 347.369 129.757 347.369Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 348,
    width: 76,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M239.062 423.499C244.167 423.71 248.923 422.619 253.368 420.259C257.986 418.745 261.944 416.139 265.312 412.477C268.923 409.062 271.493 405.012 272.986 400.364C275.312 395.892 276.389 391.033 276.18 385.857C275.729 382.512 275.312 379.202 274.861 375.857C273.09 369.483 269.93 363.955 265.312 359.237C262.812 357.265 260.312 355.328 257.812 353.356C252.014 349.941 245.764 348.25 239.062 348.215C233.958 348.004 229.201 349.095 224.757 351.455C220.139 352.969 216.18 355.575 212.812 359.237C209.201 362.652 206.632 366.702 205.139 371.35C202.812 375.822 201.736 380.681 201.944 385.857C202.396 389.202 202.812 392.512 203.264 395.857C205.035 402.231 208.194 407.759 212.812 412.477C215.312 414.449 217.812 416.386 220.312 418.358C226.146 421.773 232.361 423.499 239.062 423.499Z",
    fill: "url(#paint4_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M239.062 423.499C244.167 423.71 248.923 422.619 253.368 420.259C257.986 418.745 261.944 416.139 265.312 412.477C268.923 409.062 271.493 405.012 272.986 400.364C275.312 395.892 276.389 391.033 276.18 385.857C275.729 382.512 275.312 379.202 274.861 375.857C273.09 369.483 269.93 363.955 265.312 359.237C262.812 357.265 260.312 355.328 257.812 353.356C252.014 349.941 245.764 348.25 239.062 348.215C233.958 348.004 229.201 349.095 224.757 351.455C220.139 352.969 216.18 355.575 212.812 359.237C209.201 362.652 206.632 366.702 205.139 371.35C202.812 375.822 201.736 380.681 201.944 385.857C202.396 389.202 202.812 392.512 203.264 395.857C205.035 402.231 208.194 407.759 212.812 412.477C215.312 414.449 217.812 416.386 220.312 418.358C226.146 421.773 232.361 423.499 239.062 423.499Z",
    fill: "url(#paint5_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M239.132 390.855C244.479 390.855 244.513 382.404 239.132 382.404C233.784 382.404 233.784 390.855 239.132 390.855Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 59,
    width: 75,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.271 134.511C139.376 134.722 144.132 133.63 148.577 131.271C153.195 129.757 157.153 127.151 160.521 123.489C164.132 120.074 166.702 116.024 168.195 111.376C170.521 106.904 171.598 102.045 171.389 96.8688C170.938 93.5236 170.521 90.2137 170.07 86.8685C168.299 80.4951 165.139 74.9668 160.521 70.2483C158.021 68.2764 155.521 66.3398 153.021 64.3679C147.223 60.9523 140.973 59.2621 134.271 59.2269C129.167 59.0156 124.41 60.1072 119.966 62.4664C115.348 63.9805 111.389 66.5862 108.021 70.2483C104.41 73.6639 101.841 77.7133 100.348 82.3613C98.0213 86.8333 96.945 91.6926 97.1533 96.8688C97.6047 100.214 98.0213 103.524 98.4727 106.869C100.244 113.242 103.403 118.771 108.021 123.489C110.521 125.461 113.021 127.398 115.521 129.37C121.32 132.785 127.57 134.511 134.271 134.511Z",
    fill: "url(#paint6_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.271 134.511C139.376 134.722 144.132 133.63 148.577 131.271C153.195 129.757 157.153 127.151 160.521 123.489C164.132 120.074 166.702 116.024 168.195 111.376C170.521 106.904 171.598 102.045 171.389 96.8688C170.938 93.5236 170.521 90.2137 170.07 86.8685C168.299 80.4951 165.139 74.9668 160.521 70.2483C158.021 68.2764 155.521 66.3398 153.021 64.3679C147.223 60.9523 140.973 59.2621 134.271 59.2269C129.167 59.0156 124.41 60.1072 119.966 62.4664C115.348 63.9805 111.389 66.5862 108.021 70.2483C104.41 73.6639 101.841 77.7133 100.348 82.3613C98.0213 86.8333 96.945 91.6926 97.1533 96.8688C97.6047 100.214 98.0213 103.524 98.4727 106.869C100.244 113.242 103.403 118.771 108.021 123.489C110.521 125.461 113.021 127.398 115.521 129.37C121.32 132.785 127.57 134.511 134.271 134.511Z",
    fill: "url(#paint7_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M134.34 101.869C139.687 101.869 139.722 93.418 134.34 93.418C128.958 93.418 128.958 101.869 134.34 101.869Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 98,
    width: 75,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M270.729 173.632C275.834 173.843 280.59 172.751 285.035 170.392C289.653 168.878 293.611 166.272 296.979 162.61C300.59 159.195 303.16 155.145 304.653 150.497C306.979 146.025 308.056 141.166 307.847 135.99C307.396 132.645 306.979 129.335 306.528 125.99C304.757 119.616 301.597 114.088 296.979 109.369C294.479 107.398 291.979 105.461 289.479 103.489C283.681 100.073 277.431 98.3832 270.729 98.348C265.625 98.1367 260.868 99.2283 256.424 101.588C251.806 103.102 247.847 105.707 244.479 109.369C240.868 112.785 238.299 116.834 236.806 121.482C234.479 125.954 233.403 130.814 233.611 135.99C234.063 139.335 234.479 142.645 234.931 145.99C236.702 152.364 239.861 157.892 244.479 162.61C246.979 164.582 249.479 166.519 251.979 168.491C257.778 171.906 264.028 173.597 270.729 173.632Z",
    fill: "url(#paint8_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M270.729 173.632C275.834 173.843 280.59 172.751 285.035 170.392C289.653 168.878 293.611 166.272 296.979 162.61C300.59 159.195 303.16 155.145 304.653 150.497C306.979 146.025 308.056 141.166 307.847 135.99C307.396 132.645 306.979 129.335 306.528 125.99C304.757 119.616 301.597 114.088 296.979 109.369C294.479 107.398 291.979 105.461 289.479 103.489C283.681 100.073 277.431 98.3832 270.729 98.348C265.625 98.1367 260.868 99.2283 256.424 101.588C251.806 103.102 247.847 105.707 244.479 109.369C240.868 112.785 238.299 116.834 236.806 121.482C234.479 125.954 233.403 130.814 233.611 135.99C234.063 139.335 234.479 142.645 234.931 145.99C236.702 152.364 239.861 157.892 244.479 162.61C246.979 164.582 249.479 166.519 251.979 168.491C257.778 171.906 264.028 173.597 270.729 173.632Z",
    fill: "url(#paint9_radial)",
    stroke: "url(#paint10_radial)",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M270.799 140.99C276.146 140.99 276.181 132.539 270.799 132.539C265.452 132.539 265.417 140.99 270.799 140.99Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 114,
    width: 75,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1532 189.899C42.2573 190.111 47.0143 189.019 51.4587 186.66C56.0768 185.146 60.0351 182.54 63.4032 178.878C67.0143 175.462 69.5837 171.413 71.0768 166.765C73.4032 162.293 74.4796 157.434 74.2712 152.257C73.8198 148.912 73.4032 145.602 72.9518 142.257C71.181 135.884 68.0212 130.355 63.4032 125.637C60.9032 123.665 58.4032 121.728 55.9032 119.757C50.1046 116.341 43.8546 114.651 37.1532 114.616C32.049 114.404 27.2921 115.496 22.8476 117.855C18.2296 119.369 14.2712 121.975 10.9032 125.637C7.29207 129.053 4.72262 133.102 3.22957 137.75C0.903178 142.222 -0.173211 147.081 0.035122 152.257C0.486511 155.603 0.903178 158.913 1.35457 162.258C3.1254 168.631 6.28512 174.159 10.9032 178.878C13.4032 180.85 15.9032 182.786 18.4032 184.758C24.2018 188.174 30.4518 189.864 37.1532 189.899Z",
    fill: "url(#paint11_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1532 189.899C42.2573 190.111 47.0143 189.019 51.4587 186.66C56.0768 185.146 60.0351 182.54 63.4032 178.878C67.0143 175.462 69.5837 171.413 71.0768 166.765C73.4032 162.293 74.4796 157.434 74.2712 152.257C73.8198 148.912 73.4032 145.602 72.9518 142.257C71.181 135.884 68.0212 130.355 63.4032 125.637C60.9032 123.665 58.4032 121.728 55.9032 119.757C50.1046 116.341 43.8546 114.651 37.1532 114.616C32.049 114.404 27.2921 115.496 22.8476 117.855C18.2296 119.369 14.2712 121.975 10.9032 125.637C7.29207 129.053 4.72262 133.102 3.22957 137.75C0.903178 142.222 -0.173211 147.081 0.035122 152.257C0.486511 155.603 0.903178 158.913 1.35457 162.258C3.1254 168.631 6.28512 174.159 10.9032 178.878C13.4032 180.85 15.9032 182.786 18.4032 184.758C24.2018 188.174 30.4518 189.864 37.1532 189.899Z",
    fill: "url(#paint12_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M37.222 157.258C42.5692 157.258 42.6039 148.807 37.222 148.807C31.8401 148.807 31.8401 157.258 37.222 157.258Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 232,
    width: 75,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.326 307.931C47.4302 308.142 52.1871 307.05 56.6316 304.691C61.2496 303.177 65.208 300.571 68.576 296.909C72.1871 293.494 74.7566 289.444 76.2496 284.796C78.576 280.324 79.6524 275.465 79.4441 270.289C78.9927 266.944 78.576 263.634 78.1246 260.288C76.3538 253.915 73.1941 248.387 68.576 243.668C66.076 241.696 63.576 239.76 61.076 237.788C55.2774 234.372 49.0274 232.682 42.326 232.647C37.2219 232.436 32.4649 233.527 28.0205 235.886C23.4371 237.4 19.4441 239.971 16.076 243.668C12.4649 247.084 9.89547 251.133 8.40242 255.781C6.07603 260.253 4.99964 265.113 5.20797 270.289C5.65936 273.634 6.07603 276.944 6.52742 280.289C8.29825 286.662 11.458 292.191 16.076 296.909C18.576 298.881 21.076 300.818 23.576 302.79C29.4094 306.17 35.6246 307.895 42.326 307.931Z",
    fill: "url(#paint13_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.326 307.931C47.4302 308.142 52.1871 307.05 56.6316 304.691C61.2496 303.177 65.208 300.571 68.576 296.909C72.1871 293.494 74.7566 289.444 76.2496 284.796C78.576 280.324 79.6524 275.465 79.4441 270.289C78.9927 266.944 78.576 263.634 78.1246 260.288C76.3538 253.915 73.1941 248.387 68.576 243.668C66.076 241.696 63.576 239.76 61.076 237.788C55.2774 234.372 49.0274 232.682 42.326 232.647C37.2219 232.436 32.4649 233.527 28.0205 235.886C23.4371 237.4 19.4441 239.971 16.076 243.668C12.4649 247.084 9.89547 251.133 8.40242 255.781C6.07603 260.253 4.99964 265.113 5.20797 270.289C5.65936 273.634 6.07603 276.944 6.52742 280.289C8.29825 286.662 11.458 292.191 16.076 296.909C18.576 298.881 21.076 300.818 23.576 302.79C29.4094 306.17 35.6246 307.895 42.326 307.931Z",
    fill: "url(#paint14_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M42.3962 275.256C47.7434 275.256 47.7781 266.805 42.3962 266.805C37.0489 266.805 37.0489 275.256 42.3962 275.256Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 209,
    width: 75,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.639 284.725C137.743 284.937 142.5 283.845 146.944 281.486C151.562 279.972 155.52 277.366 158.889 273.704C162.5 270.288 165.069 266.239 166.562 261.591C168.889 257.119 169.965 252.26 169.757 247.084C169.305 243.738 168.889 240.428 168.437 237.083C166.666 230.71 163.507 225.182 158.889 220.463C156.389 218.491 153.889 216.555 151.389 214.583C145.59 211.167 139.34 209.477 132.639 209.442C127.534 209.23 122.777 210.322 118.333 212.681C113.715 214.195 109.757 216.801 106.389 220.463C102.777 223.879 100.208 227.928 98.7149 232.576C96.3885 237.048 95.3121 241.907 95.5205 247.084C95.9719 250.429 96.3885 253.739 96.8399 257.084C98.6107 263.457 101.77 268.986 106.389 273.704C108.889 275.676 111.389 277.613 113.889 279.584C119.722 283 125.937 284.725 132.639 284.725Z",
    fill: "url(#paint15_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M132.639 284.725C137.743 284.937 142.5 283.845 146.944 281.486C151.562 279.972 155.52 277.366 158.889 273.704C162.5 270.288 165.069 266.239 166.562 261.591C168.889 257.119 169.965 252.26 169.757 247.084C169.305 243.738 168.889 240.428 168.437 237.083C166.666 230.71 163.507 225.182 158.889 220.463C156.389 218.491 153.889 216.555 151.389 214.583C145.59 211.167 139.34 209.477 132.639 209.442C127.534 209.23 122.777 210.322 118.333 212.681C113.715 214.195 109.757 216.801 106.389 220.463C102.777 223.879 100.208 227.928 98.7149 232.576C96.3885 237.048 95.3121 241.907 95.5205 247.084C95.9719 250.429 96.3885 253.739 96.8399 257.084C98.6107 263.457 101.77 268.986 106.389 273.704C108.889 275.676 111.389 277.613 113.889 279.584C119.722 283 125.937 284.725 132.639 284.725Z",
    fill: "url(#paint16_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M132.709 252.084C138.056 252.084 138.091 243.633 132.709 243.633C127.361 243.633 127.361 252.084 132.709 252.084Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 430,
    width: 75,
    height: 77
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.841 506.001C131.945 506.212 136.702 505.121 141.146 502.761C145.764 501.247 149.723 498.642 153.091 494.98C156.702 491.564 159.271 487.515 160.764 482.867C163.091 478.395 164.167 473.535 163.959 468.359C163.507 465.014 163.091 461.704 162.639 458.359C160.868 451.985 157.709 446.457 153.091 441.739C150.591 439.767 148.091 437.83 145.591 435.858C139.792 432.443 133.542 430.752 126.841 430.717C121.737 430.506 116.98 431.597 112.535 433.957C107.917 435.471 103.959 438.077 100.591 441.739C96.9796 445.154 94.4101 449.204 92.9171 453.852C90.5907 458.324 89.5143 463.183 89.7226 468.359C90.174 471.704 90.5907 475.014 91.0421 478.359C92.8129 484.733 95.9726 490.261 100.591 494.98C103.091 496.951 105.591 498.888 108.091 500.86C113.889 504.24 120.139 505.966 126.841 506.001Z",
    fill: "url(#paint17_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.841 506.001C131.945 506.212 136.702 505.121 141.146 502.761C145.764 501.247 149.723 498.642 153.091 494.98C156.702 491.564 159.271 487.515 160.764 482.867C163.091 478.395 164.167 473.535 163.959 468.359C163.507 465.014 163.091 461.704 162.639 458.359C160.868 451.985 157.709 446.457 153.091 441.739C150.591 439.767 148.091 437.83 145.591 435.858C139.792 432.443 133.542 430.752 126.841 430.717C121.737 430.506 116.98 431.597 112.535 433.957C107.917 435.471 103.959 438.077 100.591 441.739C96.9796 445.154 94.4101 449.204 92.9171 453.852C90.5907 458.324 89.5143 463.183 89.7226 468.359C90.174 471.704 90.5907 475.014 91.0421 478.359C92.8129 484.733 95.9726 490.261 100.591 494.98C103.091 496.951 105.591 498.888 108.091 500.86C113.889 504.24 120.139 505.966 126.841 506.001Z",
    fill: "url(#paint18_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M126.91 473.324C132.257 473.324 132.292 464.873 126.91 464.873C121.563 464.873 121.528 473.324 126.91 473.324Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 167,
    width: 76,
    height: 77
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M204.098 243.001C209.202 243.212 213.959 242.121 218.403 239.761C223.021 238.247 226.979 235.642 230.348 231.979C233.959 228.564 236.528 224.514 238.021 219.866C240.348 215.395 241.424 210.535 241.216 205.359C240.764 202.014 240.348 198.704 239.896 195.359C238.125 188.985 234.966 183.457 230.348 178.739C227.848 176.767 225.348 174.83 222.848 172.858C217.049 169.443 210.799 167.752 204.098 167.717C198.993 167.506 194.236 168.597 189.792 170.957C185.174 172.471 181.216 175.076 177.848 178.739C174.236 182.154 171.667 186.204 170.174 190.852C167.848 195.324 166.771 200.183 166.979 205.359C167.431 208.704 167.848 212.014 168.299 215.359C170.07 221.733 173.229 227.261 177.848 231.979C180.348 233.951 182.848 235.888 185.348 237.86C191.146 241.24 197.396 242.966 204.098 243.001Z",
    fill: "url(#paint19_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M204.098 243.001C209.202 243.212 213.959 242.121 218.403 239.761C223.021 238.247 226.979 235.642 230.348 231.979C233.959 228.564 236.528 224.514 238.021 219.866C240.348 215.395 241.424 210.535 241.216 205.359C240.764 202.014 240.348 198.704 239.896 195.359C238.125 188.985 234.966 183.457 230.348 178.739C227.848 176.767 225.348 174.83 222.848 172.858C217.049 169.443 210.799 167.752 204.098 167.717C198.993 167.506 194.236 168.597 189.792 170.957C185.174 172.471 181.216 175.076 177.848 178.739C174.236 182.154 171.667 186.204 170.174 190.852C167.848 195.324 166.771 200.183 166.979 205.359C167.431 208.704 167.848 212.014 168.299 215.359C170.07 221.733 173.229 227.261 177.848 231.979C180.348 233.951 182.848 235.888 185.348 237.86C191.146 241.24 197.396 242.966 204.098 243.001Z",
    fill: "url(#paint20_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M204.166 210.322C209.514 210.322 209.548 201.871 204.166 201.871C198.784 201.871 198.784 210.322 204.166 210.322Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 0,
    width: 75,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226.632 75.495C231.736 75.7063 236.493 74.6147 240.937 72.2555C245.555 70.7414 249.514 68.1357 252.882 64.4736C256.493 61.058 259.062 57.0086 260.555 52.3606C262.882 47.8886 263.958 43.0294 263.75 37.8532C263.298 34.508 262.882 31.198 262.43 27.8529C260.659 21.4795 257.5 15.9511 252.882 11.2327C250.382 9.26081 247.882 7.32414 245.382 5.35225C239.583 1.93666 233.333 0.211261 226.632 0.211261C221.528 -1.23978e-05 216.736 1.09157 212.326 3.45079C207.708 4.96491 203.75 7.57062 200.382 11.2327C196.771 14.6483 194.201 18.6625 192.708 23.3457C190.382 27.8177 189.305 32.677 189.514 37.8532C189.965 41.1983 190.382 44.5083 190.833 47.8534C192.604 54.2268 195.764 59.7552 200.382 64.4736C202.882 66.4455 205.382 68.3822 207.882 70.3541C213.68 73.7344 219.93 75.4598 226.632 75.495Z",
    fill: "url(#paint21_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226.632 75.495C231.736 75.7063 236.493 74.6147 240.937 72.2555C245.555 70.7414 249.514 68.1357 252.882 64.4736C256.493 61.058 259.062 57.0086 260.555 52.3606C262.882 47.8886 263.958 43.0294 263.75 37.8532C263.298 34.508 262.882 31.198 262.43 27.8529C260.659 21.4795 257.5 15.9511 252.882 11.2327C250.382 9.26081 247.882 7.32414 245.382 5.35225C239.583 1.93666 233.333 0.211261 226.632 0.211261C221.528 -1.23978e-05 216.736 1.09157 212.326 3.45079C207.708 4.96491 203.75 7.57062 200.382 11.2327C196.771 14.6483 194.201 18.6625 192.708 23.3457C190.382 27.8177 189.305 32.677 189.514 37.8532C189.965 41.1983 190.382 44.5083 190.833 47.8534C192.604 54.2268 195.764 59.7552 200.382 64.4736C202.882 66.4455 205.382 68.3822 207.882 70.3541C213.68 73.7344 219.93 75.4598 226.632 75.495Z",
    fill: "url(#paint22_radial)",
    stroke: "url(#paint23_radial)",
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M226.701 42.8181C232.049 42.8181 232.083 34.3672 226.701 34.3672C221.32 34.3672 221.32 42.8181 226.701 42.8181Z",
    fill: "#00A400"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 280,
    y: 201,
    width: 76,
    height: 76
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M317.882 276.452C322.986 276.663 327.743 275.572 332.187 273.213C336.805 271.698 340.764 269.093 344.132 265.431C347.743 262.015 350.312 257.966 351.805 253.318C354.132 248.846 355.208 243.986 355 238.81C354.548 235.465 354.132 232.155 353.68 228.81C351.909 222.436 348.75 216.908 344.132 212.19C341.632 210.218 339.132 208.281 336.632 206.309C330.833 202.894 324.583 201.204 317.882 201.168C312.778 200.957 308.021 202.049 303.576 204.408C298.958 205.922 295 208.528 291.632 212.19C288.021 215.605 285.451 219.655 283.958 224.303C281.632 228.775 280.555 233.634 280.764 238.81C281.215 242.155 281.632 245.465 282.083 248.81C283.854 255.184 287.014 260.712 291.632 265.431C294.132 267.403 296.632 269.339 299.132 271.311C304.93 274.727 311.18 276.417 317.882 276.452Z",
    fill: "url(#paint24_radial)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M317.882 276.452C322.986 276.663 327.743 275.572 332.187 273.213C336.805 271.698 340.764 269.093 344.132 265.431C347.743 262.015 350.312 257.966 351.805 253.318C354.132 248.846 355.208 243.986 355 238.81C354.548 235.465 354.132 232.155 353.68 228.81C351.909 222.436 348.75 216.908 344.132 212.19C341.632 210.218 339.132 208.281 336.632 206.309C330.833 202.894 324.583 201.204 317.882 201.168C312.778 200.957 308.021 202.049 303.576 204.408C298.958 205.922 295 208.528 291.632 212.19C288.021 215.605 285.451 219.655 283.958 224.303C281.632 228.775 280.555 233.634 280.764 238.81C281.215 242.155 281.632 245.465 282.083 248.81C283.854 255.184 287.014 260.712 291.632 265.431C294.132 267.403 296.632 269.339 299.132 271.311C304.93 274.727 311.18 276.417 317.882 276.452Z",
    fill: "url(#paint25_radial)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M317.952 243.808C323.299 243.808 323.333 235.357 317.952 235.357C312.57 235.357 312.57 243.808 317.952 243.808Z",
    fill: "#00A400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.016 310.261) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.016 310.261) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.697 342.367) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.697 342.367) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.078 385.87) scale(37.1415 37.6656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.078 385.87) scale(37.1415 37.6656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.261 96.8781) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.261 96.8781) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.734 135.985) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.734 135.985) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.734 135.985) scale(37.3151 37.8418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#00A400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1419 152.251) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1419 152.251) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3397 270.271) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3397 270.271) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.654 247.093) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.654 247.093) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.847 468.347) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.847 468.347) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.084 205.342) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.084 205.342) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.628 37.8417) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.628 37.8417) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.628 37.8417) scale(37.3151 37.8418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#00A400",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.869 238.803) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2049,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6121,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(317.869 238.803) scale(37.1415 37.6657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2044,
    stopColor: "#007700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4678,
    stopColor: "#004400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6978,
    stopColor: "#001F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#000800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 506,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face.ad573cdc.svg";
export { ForwardRef as ReactComponent };